import React from 'react';
import DancingBeetle from './DancingBeetle';
import './App.css';

function App() {
  return (
    <div className="App">
      <h1 style={{
        position: 'absolute',
        top: '20px',
        left: '50%',
        transform: 'translateX(-50%)',
        color: '#2F4F2F',
        fontFamily: 'Courier New, monospace',
        fontSize: '2rem',
        textShadow: '2px 2px 4px rgba(0,0,0,0.3)',
        margin: 0,
        zIndex: 1000
      }}>
        🎵 Dancing Pixel Beetle 🎵
      </h1>
      <DancingBeetle />
    </div>
  );
}

export default App;
